import { render, staticRenderFns } from "./TakipAcFormWizard.vue?vue&type=template&id=61f02319&scoped=true"
import script from "./TakipAcFormWizard.vue?vue&type=script&lang=ts"
export * from "./TakipAcFormWizard.vue?vue&type=script&lang=ts"
import style0 from "./TakipAcFormWizard.vue?vue&type=style&index=0&id=61f02319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f02319",
  null
  
)

export default component.exports